import React from 'react';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import TagActivationForm from './TagActivationForm';

import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { removeEmptyKeys } from '../validations';

const initialValues = {
  accessTagUsersAndNumbers: [{ userName: '', tagNumber: '' }],
  municipality: null,
  office: null,
  building: null,
  accessGroup: '',
  additionalRequirements: '',
  ordererPhone: '',
};

const isInvalidTagUserAndNumber = ({ tagNumber }) => !tagNumber;

const validate = values => {
  const errors = {};

  if (values.accessTagUsersAndNumbers.length === 0) {
    errors.accessTagUsersAndNumbers = 'Lisää ainakin yksi aktivoitava tunniste';
  }

  if (values.accessTagUsersAndNumbers.some(isInvalidTagUserAndNumber)) {
    errors.accessTagUsersAndNumbers =
      'Tarkista, että jokaisella tunnisteella on numero';
  }

  if (!values.office) {
    errors.office = 'Vaadittu';
  }

  if (!values.building) {
    errors.building = 'Vaadittu';
  }

  if (!values.accessGroup) {
    errors.accessGroup = 'Vaadittu';
  }

  if (!values.ordererPhone) {
    errors.ordererPhone = 'Vaadittu';
  }

  return removeEmptyKeys(errors);
};

const TagActivation = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;

        await method({
          fields: {
            ...values,
            organization: values.organization?.value,
            municipality: values.municipality?.value,
            office: values.office?.value,
            building: values.building?.value,
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          formik={formikProps}
          Component={TagActivationForm}
        />
      )}
    </Formik>
  );
};

export default TagActivation;
